import styled from 'styled-components'
import { isMobile } from './../helpers'

export const HEADER_HEIGHT = 18.5
export const SEARCHBAR_HEIGHT = 10

const StyledLayout = styled.div`
	${props =>
		props.noPadding ||
		`
        .body {
            padding-top: ${isMobile()? '0' : '21.5rem'};

            @media screen and (max-width: 415px) {
                padding-top: ${isMobile()? '10px' : '34.5rem'};
            }
        }
    `};
`

export default StyledLayout
